import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { SecureGate } from "@/components/SecureGate";

export function CancelJobDialog({ job, open, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/jobs/${job.id}/cancel`, { reason });
      toast.success("Intervento annullato: avviso inviato al cliente su WhatsApp");
      setReason("");
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="cancel-job-dialog">
        <DialogHeader><DialogTitle className="font-display">Annulla intervento</DialogTitle></DialogHeader>
        <SecureGate description="Inserisci la seconda password per annullare l'intervento. Resta sbloccata per 30 minuti.">
          <p className="text-sm text-slate-600">L'intervento di <b>{job.client.first_name} {job.client.last_name}</b> del {job.date} alle {job.start} verrà annullato.
            Il cliente riceverà l'avviso di annullamento su WhatsApp{job.technician_name ? ` e ${job.technician_name} una notifica` : ""}.</p>
          <Textarea rows={2} value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300} placeholder="Motivo (facoltativo, solo per uso interno)" data-testid="cancel-job-reason" />
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={onClose} data-testid="cancel-job-back">Indietro</Button>
            <Button className="rounded-full bg-red-600 hover:bg-red-700" onClick={submit} disabled={busy} data-testid="cancel-job-confirm">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Annulla intervento</Button>
          </DialogFooter>
        </SecureGate>
      </DialogContent>
    </Dialog>
  );
}
